export default __webpack_public_path__ + "static/media/algolia.155bab77.svg";